import { v4 } from "uuid";

export const CustomerInitiatesChatType = "CustomerInitiatesChat";
export const CustomerSendsTextType = "CustomerSendsText";
export const CustomerSendsMediaType = "CustomerSendsMedia";
export const ValidateStaleConversationIdType = "ValidateStaleConversationId";
export const CustomerEndsChatType = "CustomerEndsChat"
export const DrainBacklogMessageType = 'DrainBacklogMessage'
export const AgentMessageAckType = 'AgentMessageAck'

export function CustomerIsTyping() {
  return {
    _type: "CustomerIsTyping",
  };
}

export function CustomerInitiatesChat(
  name,
  email,
  phoneNumber,
  chatSubject,
  captchaId,
  captchaAnswer,
  customFields,
  origin
) {
  return {
    name,
    email,
    phoneNumber,
    chatSubject,
    captchaValidation:
      captchaId && captchaAnswer
        ? {
          captchaId,
          answer: captchaAnswer,
        }
        : null,
    customFields,
    origin,
    _type: CustomerInitiatesChatType,
  };
}

export function CustomerEndsChat() {
  return {
    _type: CustomerEndsChatType
  }
}

export function CustomerSendsText(text) {
  return {
    text,
    _type: CustomerSendsTextType,    
    clientSideId: v4()
  };
}

export function ValidateStaleConversationId(chatRoomId) {
  return {
    _type: ValidateStaleConversationIdType,
    chatRoomId,
  };
}

export function CustomerSendsMedia(fileName, size, fileUri, contentType) {
  return {
    _type: CustomerSendsMediaType,
    fileName,
    size,
    fileUri,
    contentType,
    clientSideId: v4()
  };
}

export function DrainBacklogMessage(chatRoomId, ts) {
  return {
    _type: DrainBacklogMessageType,
    from: ts,
    chatRoomId
  }
}

export function AgentMessageAck(serverSideId) {
  return {
    _type: AgentMessageAckType,
    serverSideId
  }
}